var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Entity, EntityBuilder } from '@decahedron/entity';
import { NotificationsData } from 'packages/notifications/NotificationData';
import { MessageNotificationData } from 'packages/notifications/MessageNotificationData';
import { MovedNotificationData } from 'packages/notifications/MovedNotificationData';
import { BulkMoveNotificationData } from 'packages/notifications/BulkMoveNotificationData';
var notificationDataMap = {
    new_talent: NotificationsData,
    talent_moved: MovedNotificationData,
    inbound_email: MessageNotificationData,
    talent_comment: NotificationsData,
    talents_moved: BulkMoveNotificationData,
};
var Notification = /** @class */ (function (_super) {
    __extends(Notification, _super);
    function Notification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.read = false;
        _this.event = null;
        _this.data = null;
        _this.createdAt = null;
        return _this;
    }
    Notification.prototype.fromJson = function (json) {
        _super.prototype.fromJson.call(this, json);
        var entity = notificationDataMap[json.event];
        this.data = (entity)
            ? EntityBuilder.buildOne(entity, json.data)
            : EntityBuilder.buildOne(NotificationsData, json.data);
        return this;
    };
    return Notification;
}(Entity));
export { Notification };
